/* istanbul ignore file */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { Button, Glyphicon } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { QueryParam, withScope } from '@bingads-webui-react/scope-service';
import { withSiteMap } from '@bingads-webui-react/with-site-map';
import { getFallbackTitleStyles } from './styles/fallback-content-title';
import { getFallbackBodyStyles } from './styles/fallback-content-body';
import { openOldUI } from './get-fallback-path/open-old-ui';
import { getFallbackPath, getCurrentRoute } from './get-fallback-path/get-fallback-path';

const ContentMessage = withI18nConsumer(({ i18n }) => i18n.getString(_TL_("This feature isn't available in the new version yet.")));
const LinkMessageForFeature = withI18nConsumer(({ i18n }) => i18n.getString(_TL_('Go to this feature in previous Microsoft Advertising.')));
const LinkMessageGeneric = withI18nConsumer(({ i18n }) => i18n.getString(_TL_('Go to previous Microsoft Advertising.')));

class UnthemedFallbackContentBody extends React.PureComponent {
  render() {
    const {
      getOldUIPathOverride, scope, siteMap, siteMapId, classes,
    } = this.props;

    const clickAction = (e) => {
      this.props.handleClose(e);

      if (getOldUIPathOverride) {
        openOldUI(scope, getOldUIPathOverride);
      } else if (siteMapId) {
        openOldUI(scope, s => getFallbackPath(s, siteMap, { id: siteMapId }));
      } else {
        const currentRoute = getCurrentRoute(scope);
        openOldUI(scope, s => getFallbackPath(s, siteMap, { route: currentRoute }));
      }
    };

    const LinkMessage = siteMapId || getOldUIPathOverride
      ? LinkMessageForFeature
      : LinkMessageGeneric;

    return (
      <React.Fragment>
        <div className={classNames([classes.message, 'bingads-webui-campaign-react-fallback-callout-message'])}>
          <ContentMessage />
        </div>
        <div>
          <Button
            className={classNames([classes.link, 'bingads-webui-campaign-react-fallback-callout-link'])}
            onClick={clickAction}
            btnStyle="link"
          >
            <Glyphicon glyph="ba-OpenInNewWindow" />
            <LinkMessage />
          </Button>
        </div>
      </React.Fragment>);
  }
}

const UnthemedFallbackContentTitle = ({ title, classes }) => (
  <span className={classNames([classes.title, 'bingads-webui-campaign-react-fallback-callout-title'])}>{title}</span>
);

UnthemedFallbackContentTitle.propTypes = {
  title: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
};

UnthemedFallbackContentBody.defaultProps = {
  handleClose: () => { },
  getOldUIPathOverride: null,
  siteMapId: null,
};

UnthemedFallbackContentBody.propTypes = {
  handleClose: PropTypes.func,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  classes: PropTypes.shape({
    message: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
  getOldUIPathOverride: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
  siteMapId: PropTypes.string,
  siteMap: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export const FallbackContentBody
  = withSiteMap(withScope(withDefaultStyles(UnthemedFallbackContentBody, getFallbackBodyStyles)));

export const FallbackContentTitle
  = withDefaultStyles(UnthemedFallbackContentTitle, getFallbackTitleStyles);
